const collectionTitle = document.querySelector('.collection-hero__title').innerText;

const fetchCollection = async (url, _this) => {
  try {
    const res = await fetch(url);
    const data = await res.json();
    const priceElement = _this.querySelector('.js-Product_Price');
    const sizeElement = _this.querySelector('.js-Product_size');
    const sizeTextElement = _this.querySelector('.js-size');
    const coloursElement = _this.querySelector('.prd-Card_Colours');
    const badgeElement = _this.querySelector('.js-card__content');
    if((data.size === 0 || data.size === undefined)  && data.price_min_value === '£0'){
      _this.style.display = 'none';
      return;
    } 
    if (priceElement && data.price_min_value) priceElement.innerHTML = data.price_min_value;
    if (sizeElement && data.size) sizeElement.innerHTML = data.size;
    if(data.size == 1) sizeTextElement.innerHTML = 'size';
    let dataHtml = `<ul class="prd-Colours_Items list-unstyled">`;
    if (data.colour) {
      const colours = data.colour.split('|').filter(c => c.trim() !== '');
      colours.slice(0, 5).forEach(colour => {
        let border;
        if(colour == '#ffffff') border = 'border-color:#e5e5e5;';
        dataHtml += `<li class="prd-Colours_Item"><span class="prd-Colours_Button" style="--Swatch_Color: ${colour};${border}"></span></li>`;
      });
      if (colours.length > 8) dataHtml += `<li class="prd-Colours_Item prd-Colours_Item-total">+${colours.length - 5}</li>`;
    }
    dataHtml += `</ul>`;
    if (data.colour) {
      const colours = data.colour.split('|').filter(c => c.trim() !== '');
      if(colours.length == 1){
        dataHtml += `<span class="prd-Colours_Item-total">${colours.length} colour</span>`;
      }else{
        dataHtml += `<span class="prd-Colours_Item-total">${colours.length} colours</span>`;
      }
    }
    if (coloursElement) coloursElement.innerHTML = dataHtml;
    if(data.discount_percentage) {
      badgeElement.querySelector('.badge').innerHTML = data.discount_percentage;
      badgeElement.style.display = 'flex';
    }
  } catch (error) {
    console.error('Error fetching data:', error);
    _this.style.display = 'none';
  }
};

document.querySelectorAll('.clc-Hero_Items .clc-Hero_Item').forEach(el => {
  const subSectionText = el.querySelector('.clc-HeroCard_Link').innerText;
  addEventAndObserve(el, 'click', () => {
    setPlpPromotion(collectionTitle,'PLP header links',subSectionText);
  }, false);
}); 
document.querySelectorAll('.sec-CollectionFAQs_Columns .sec-CollectionFAQs_PillListItem').forEach(el => {
  const subSectionText = el.innerText;
  addEventAndObserve(el, 'click', () => {
    setPlpPromotion(collectionTitle,'PLP footer links',subSectionText);
  }, false);
}); 
document.querySelectorAll('.sec-collection-feature-blog .blog__post').forEach(el => {
  const subSectionText = el.querySelector('.card__heading a').innerText;
  addEventAndObserve(el, 'click', () => {
    setPlpPromotion(collectionTitle,'PLP Blog carousel',subSectionText);
  }, false);
}); 
document.querySelector('[data-el="un-truncate.triggerOpen"]') && document.querySelector('[data-el="un-truncate.triggerOpen"]').addEventListener('click', (event) => {
  document.querySelector('.un-truncate-content').style.display = 'none';
  document.querySelector('[data-el="un-truncate.fullContent"]').style.display = 'block';
});
document.querySelector('[data-el="un-truncate.triggerClose"]') && document.querySelector('[data-el="un-truncate.triggerClose"]').addEventListener('click', (event) => {
  document.querySelector('.un-truncate-content').style.display = 'block';
  document.querySelector('[data-el="un-truncate.fullContent"]').style.display = 'none';
});
document.addEventListener("DOMContentLoaded", (event) => {
  const _thisCollection = document.querySelector('#product-promo-grid');
  if(_thisCollection){
    _thisCollection.querySelectorAll(".promotion-combined_collection").forEach(function (item) {
      const handle = item.getAttribute('data-handle');
      fetchCollection(`/collections/${handle}?view=json`,item);
    });
  }
});
class StickyFilters extends HTMLElement {
  constructor() {
    super();
    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.isScrolling = null;
    this.filterBounds = {};
    this.onScrollHandler = this.onScroll.bind(this);
    this.filter = document.querySelector('.acs_collection_results');
    this.hero = document.querySelector('.collection-hero');
    this.hideFilterOnScrollUp = () => (this.preventReveal = true);
    this.createObserver();
  }

  connectedCallback() {
    this.addEventListener('preventHeaderReveal', this.hideFilterOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideFilterOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    const observer = new IntersectionObserver(entries => {
      const entry = entries[0];   
      const target = entry.target;
      this.filterBounds = entry.boundingClientRect;
      observer.unobserve(target);
    });
    observer.observe(this.filter);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const headerHeight = document.querySelector('.header-wrapper')?.offsetHeight || 0;
    const heroBottom = this.hero
      ? (this.hero.getBoundingClientRect().top + window.pageYOffset + this.hero.offsetHeight - headerHeight)
      : 0;
    const stopSticky = this.filterBounds.top - (headerHeight + 20);
    const bottomSticky = stopSticky + (this.offsetHeight);
    const atTop = scrollTop <= (headerHeight + 5);
    const heroVisible = this.hero ? scrollTop < heroBottom : false;
    if (this.currentScrollTop === scrollTop) return;
    if (atTop || heroVisible) {
      this.resetFilter();
    } else if (scrollTop > this.currentScrollTop && scrollTop > bottomSticky) {
      this.hideFilter();
    } else if (scrollTop < this.currentScrollTop && scrollTop > bottomSticky) {
      this.revealFilter();
    } else if (scrollTop <= stopSticky) {
      this.resetFilter();
    }

    this.currentScrollTop = scrollTop;
  }

  hideFilter() {
    if (this.preventReveal) return;
    requestAnimationFrame(() => {
      this.filter.classList.add('filters-hidden', 'filters-sticky');
    });
  }

  revealFilter() {
    if (this.preventReveal) return;
    requestAnimationFrame(() => {
      this.filter.classList.remove('filters-hidden');
      this.filter.classList.add('filters-sticky', 'animate');
    });
    this.debouncePreventReveal();
  }

  resetFilter() {
    requestAnimationFrame(() => {
      this.filter.classList.remove('filters-hidden', 'filters-sticky', 'animate');
    });
  }

  debouncePreventReveal() {
    window.clearTimeout(this.isScrolling);
    this.isScrolling = setTimeout(() => {
      this.preventReveal = false;
    }, 66);
  }
}